import { ListTerrotoriesSortFields, ListTerrotoriesSortOrder } from 'generated/graphql'

export const DEFAULT_SORT = {
  field: ListTerrotoriesSortFields.AvgEngagement,
  order: ListTerrotoriesSortOrder.Desc,
}

export const PAGINATION_LIMIT = 25
export const DEFAULT_TIME = 12

export const GLOBAL_TAXONOMY_TERRITORY_TYPES: readonly string[] = [
  'theme',
  'segment',
  'subject',
  'entity_query',
  'entity',
]

export const GLOBAL_TAXONOMY_TYPES_WITH_CHILDREN: readonly string[] = ['theme', 'segment', 'subject']

export const GLOBAL_TAXONOMY_THEMES_LIMIT = 100

export const TERRITORY_TRAIL_PARAM = 'trail'

export const TERRITORY_TRAIL_SEPARATOR = ','
